import { useMutation } from '@tanstack/react-query';
import { notification } from 'antd';

import { apiV1 } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

export type DeleteEventDTO = {
  id: string;
  companyId: string;
};

export const deleteEvent = async (data: DeleteEventDTO): Promise<unknown> => {
  return apiV1.delete(`/v1/irm/event/${data.id}`);
};

type UseDeleteEventOptions = {
  config?: MutationConfig<typeof deleteEvent>;
  invalidateOnSuccess?: boolean;
  showSuccessNotification?: boolean;
};

export const useDeleteEvent = ({
  config,
  invalidateOnSuccess = true,
  showSuccessNotification = true,
}: UseDeleteEventOptions = {}) => {
  const { onSuccess, onError, ...restConfig } = config ?? {};

  return useMutation({
    onError: (error, variables, context) => {
      notification.error({
        message: `Não foi possível deletar o evento.`,
      });
      onError?.(error, variables, context);
    },
    onSuccess: (data, variables, context) => {
      if (invalidateOnSuccess) {
        queryClient.invalidateQueries(['events', variables.companyId]);
      }

      if (showSuccessNotification) {
        notification.success({ message: `Evento deletado com sucesso.` });
      }

      onSuccess?.(data, variables, context);
    },
    ...restConfig,
    mutationFn: deleteEvent,
  });
};
